import clsx from 'clsx';

import './SectionCard.scss';

import useResources from 'hooks/useResources';

import check from 'assets/icons/check_circle_24px.svg';

import { SectionStatus } from 'types/zod/section-status';

interface SectionProps {
    name: string;
    status: SectionStatus;
    onButtonClick?: (name: string) => void;
}

const SectionCard = (props: SectionProps) => {
    const { name, status, onButtonClick } = props;

    const { t } = useResources(['common', 'ep']);

    return (
        <div
            className={clsx('section-card', 'pointer', {
                'in-progress': status === 'inProgress',
                'up-next': status === 'notStarted',
                completed: status === 'complete',
            })}
            data-qaid={`${name}_${status}`}
            onClick={() => {
                onButtonClick && onButtonClick(name);
            }}
        >
            {status === 'complete' && <img src={check} alt="check mark" />}
            <div className="text">
                <div className="title">{name ? t(`ep:sections.${name}.title`) : ''}</div>
                <div className="description">{name ? t(`ep:sections.${name}.description`) : ''}</div>
            </div>
        </div>
    );
};

export default SectionCard;
